function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M47.586 1.698L17.389 7.022v34.642c-2.056-1.02-4.795-1.211-7.444-.315-4.437 1.501-6.957 5.5-5.627 8.897 1.33 3.396 6.013 4.934 10.45 3.433 3.75-1.27 6.133-4.326 5.976-7.286V10.91l23.487-4.133V37.18c-2.056-1.02-4.795-1.212-7.444-.315-4.437 1.5-6.957 5.5-5.627 8.897 1.33 3.396 6.013 4.933 10.45 3.432 3.75-1.269 6.133-4.326 5.976-7.285V6.042z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#000"
});

var SvgMusicnote = function SvgMusicnote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMusicnote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Music note.563159f9.svg";
export { ForwardRef as ReactComponent };